module.exports = __webpack_public_path__ + "img/grid-dots-bottom.8a8f91a3.svg";